/**
 * @description AutoLoadModal implementation
 * @param Modal Base widget for extending
 * @returns Auto Load Modal class
 */
export default function (Modal: import('widgets/global/Modal').TModal) {
    /**
     * @category widgets
     * @subcategory global
     * @class AutoLoadModal
     * @augments Modal
     * @classdesc This component can be used for auto loading modal, on a global level
     * it open it could not be closed.
     * @property {string} data-widget - Widget name `autoLoadModal`
     * <div
     *     class="b-auto-load-modal"
     *     data-widget="autoLoadModal"
     * >
     * </div>
     */
    class AutoLoadModal extends Modal {
        prefs() {
            return {
                immediateLoad: true,
                isAlert: false,
                autoLoadLabel: '',
                alertDelay: 1000,
                ...super.prefs()
            };
        }

        init() {
            super.init();

            if (this.prefs().isAlert) {
                setTimeout(() => {
                    this.eventBus().emit('alert.show', { accessibilityAlert: this.prefs().autoLoadLabel });
                }, this.prefs().alertDelay);
            } else if (this.prefs().immediateLoad) {
                this.showModal();
            }
        }
    }

    return AutoLoadModal;
}
